<template>
  <div class="style-unit">
    <div class="pic">
      <img :src="iconUrl" width="100%" height="100%">
    </div>
    <div class="text">
      <p class="top">{{name}}</p>
      <p class="bottom" v-if="mode === 1 || price!==''" :class="model"><span class="model">{{modelcn}}</span><span class="price" v-if="price!==''">{{price}}</span></p>
      <cube-checkbox v-if="mode === 2" class="checked" :option="reOption()" v-model="checked"  @input="selectItem"></cube-checkbox>
      <button v-else class="btn" :style="btnStr=='查看'?'width:68px':'width:88px'" @click="preview(price)">{{btnStr}}</button>
    </div>
    <div class="cover" v-if="mode === 2 && price!==''"></div>
  </div>
</template>
<script>
export default {
  name: 'StyleUnit',
  props: {
    src: String,
    name: String,
    model: String,
    modelcn: String,
    isUse: {
      type: Boolean,
      default: false
    },
    price: String,
    mode: Number,
    id: Number,
    selectLen: Number,
    iconUrl: String,
    btnStr: String,
    crowdfund: Boolean
  },
  data () {
    return {
      checked: this.isUse
    }
  },
  methods: {
    reOption () {
      let option = {
        label: '',
        value: '',
        disabled: false
      }
      if (this.selectLen >= 3) {
        if (!this.checked) {
          option = {
            label: '',
            value: '',
            disabled: true
          }
        }
      } else {
        if (!this.checked) {
          option = {
            label: '',
            value: '',
            disabled: false
          }
        }
      }
      // console.log(option)
      return option
    },
    preview (p) {
      this.$emit('preview', p)
    },
    selectItem () {
      this.$emit('changeSelect', {'checked': this.checked, 'id': this.id})
    }
  },
  watch: {
    isUse (newValue) {
      this.checked = newValue
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
.style-unit
  width 330px
  height 114px
  background #ffffff
  border-radius 6px
  padding 15px
  box-sizing border-box
  margin 0 auto 20px
  position relative
  rowCenter()
  .pic
    width 70px
    height 70px
    border-radius 4px
    overflow hidden
  .text
    padding-left 13px
    p
      line-height 25px
      height 25px
      color #333333
    .top
      font-size 14px
    .bottom
      font-size 12px
    .isbuy
      color #334f5f
    .isuse
      font-size 15px
      color #334f5f
      position absolute
      top 40px
      right 17px
    .btn
      height 26px
      background transparent
      color #000000
      border 1px solid #000000
      font-size 12px
      line-height 25px
      border-radius 12px
      position absolute
      top 32px
      right 18px
    .checked
      position absolute
      top 32px
      right 15px
      font-size 72%
  .cover
    position absolute
    top 0
    left 0
    bottom 0
    right 0
    background rgba(255,255,255,0.4)
    z-index 9999
</style>



// WEBPACK FOOTER //
// src/pages/CutStyle/components/styleUnit.vue